<template>
  <div class="main_box">
    <div class="main_bar" v-if="false">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>
          <a href="javascript:void(0)" @click="goBack()"> 投票列表 </a>
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <span class="currentSpan">投票结果</span>
        </el-breadcrumb-item>
      </el-breadcrumb>
      <div></div>
    </div>
    <div
      class="main_body"
      v-loading="loading"
      :element-loading-text="$config.loadingText"
      :element-loading-spinner="$config.loadingSpinner"
      :element-loading-background="$config.loadingBackground"
    >
      <div class="form_bar">
        <div class="form_bar_search">
          <div class="condition_item">
            <span>排序方式：</span>
            <el-radio
              v-model="voteResult.SortType"
              label="原序号"
              @change="editVoteResultSort()"
              style="margin-right: 25px; padding-top: 5px"
              v-if="false"
            ></el-radio>
            <el-radio
              v-model="voteResult.SortType"
              label="票数"
              @change="editVoteResultSort()"
              style="padding-top: 5px"
              v-if="false"
            ></el-radio>
            <el-radio-group
              v-model="voteResult.SortType"
              size="mini"
              @change="editVoteResultSort()"
              style="margin-right: 25px"
            >
              <el-radio-button label="原序号">
                <i class="iconfont icon-xuhao"></i>
                原序号
              </el-radio-button>
              <el-radio-button label="票数">
                <i class="iconfont icon-piaoshu"></i>
                票数
              </el-radio-button>
            </el-radio-group>
          </div>
          <div class="condition_item">
            <el-link
              icon="el-icon-edit"
              v-if="voteResult.VoteType === 0 && !isEditBaseNumber"
              @click="editBaseNumber()"
            >
              修改投票总人数
            </el-link>
            <el-select
              v-model="voteResult.BaseNumberType"
              placeholder="请选择"
              size="mini"
              class="margin_right_10"
              v-if="voteResult.VoteType === 0 && isEditBaseNumber"
            >
              <el-option label="预设投票人数（默认）" value="1"> </el-option>
              <el-option label="实际投票人数" value="2"> </el-option>
              <el-option label="自定义投票人数" value="3"> </el-option>
            </el-select>
            <div
              class="margin_right_10"
              v-if="
                voteResult.VoteType === 0 &&
                isEditBaseNumber &&
                voteResult.BaseNumberType === '3'
              "
            >
              <el-input
                v-model="voteResult.CustomBaseNumber"
                size="mini"
                placeholder="请输入自定义投票人数"
              ></el-input>
            </div>
            <el-button
              type="primary"
              size="mini"
              v-if="voteResult.VoteType === 0 && isEditBaseNumber"
              @click="recreateResult()"
            >
              保存结果
            </el-button>
            <el-button
              type="primary"
              size="mini"
              v-if="voteResult.VoteType === 0 && isEditBaseNumber"
              @click="cancelEditBaseNumber()"
            >
              取消
            </el-button>
          </div>
          <div class="condition_item">
            <span v-if="voteResult.VoteType === 0"> 视图： </span>
            <el-radio
              v-model="viewType"
              label="table"
              style="margin-right: 25px; padding-top: 5px"
              v-if="voteResult.VoteType === 0 && false"
              @change="viewTypeChange()"
            >
              列表
            </el-radio>
            <el-radio
              v-model="viewType"
              label="chart"
              style="padding-top: 5px"
              v-if="voteResult.VoteType === 0 && false"
              @change="viewTypeChange()"
            >
              图形图表
            </el-radio>
            <el-radio-group
              v-model="viewType"
              size="mini"
              @change="viewTypeChange()"
              style="margin-right: 25px"
              v-if="voteResult.VoteType === 0"
            >
              <el-radio-button label="table">
                <i class="iconfont icon-liebiao"></i>
                列表
              </el-radio-button>
              <el-radio-button label="chart">
                <i class="iconfont icon-shuzhuangtu"></i>
                图形图表
              </el-radio-button>
            </el-radio-group>
          </div>
        </div>
        <div class="form_bar_btn">
          <el-button type="text" @click="goBack()">返回投票列表</el-button>
          <el-button type="primary" @click="refresh()" size="small" plain>
            刷新
          </el-button>
          <el-button
            type="primary"
            plain
            icon="el-icon-download"
            @click="exportData()"
          >
            导出
          </el-button>
          <!-- <el-radio-group v-model="radioView" size="small">
            <el-radio-button label="user">评委</el-radio-button>
            <el-radio-button label="project">待评项</el-radio-button>
          </el-radio-group> -->
        </div>
      </div>
      <div class="table-block" style="border-top: 0px">
        <div style="text-align: center; font-weight: 900; font-size: 32px">
          {{ voteResult.VoteName }}
        </div>
        <div
          style="
            text-align: center;
            font-weight: 700;
            font-size: 18px;
            color: #f56c6c;
            margin-bottom: 15px;
          "
          v-if="voteResult.Status === 1"
        >
          预览投票
        </div>
        <el-table
          :data="voteResult.VoteProjectList"
          highlight-current-row
          style="width: 100%"
          v-show="viewType === 'table'"
        >
          <el-table-column property="Ranking" label="排名" width="50">
          </el-table-column>
          <el-table-column
            label="原序号"
            width="60"
            align="center"
            key="ProjectSort"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.ProjectSort }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="姓名/项目"
            width="150"
            align="left"
            key="ProjectName"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.ProjectName }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="单位名称"
            min-width="150"
            align="left"
            key="Remark"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.Remark }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="推荐信息"
            min-width="120"
            align="left"
            key="Remark1"
          >
            <template slot-scope="scope">
              <!-- <span>{{ scope.row.Remark1 }}</span> -->
              <el-popover placement="right" width="450" trigger="click">
                <div
                  v-html="scope.row.Remark1"
                  style="overflow: auto; max-height: 450px"
                ></div>
                <div
                  v-html="scope.row.Remark1"
                  style="max-height: 50px; overflow: hidden"
                  slot="reference"
                ></div>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column
            label="基础分数"
            width="100"
            align="center"
            v-if="voteResult.IsShowBasicScore"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.ProjectBasicScore }}</span>
            </template>
          </el-table-column>
          <el-table-column
            :label="voteResult.FirstVoteItemBeforeTitle"
            width="130"
            align="center"
            key="VoteFirstNum"
            v-if="voteResult.VoteType === 0"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.VoteFirstNum }}</span>
            </template>
          </el-table-column>
          <el-table-column
            :label="voteResult.FirstVoteItemTitle"
            width="130"
            align="center"
            key="VoteNum"
            v-if="voteResult.VoteType === 0"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.VoteNum }}</span>
              <span v-if="scope.row.ProjectRecordState">
                （{{ scope.row.ProjectRecordState }}）
              </span>
            </template>
          </el-table-column>
          <!-- <el-table-column
            label="是否通过"
            width="90"
            align="center"
            key="ProjectRecordState"
            v-if="voteResult.VoteType === 0"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.ProjectRecordState }}</span>
            </template>
          </el-table-column> -->

          <el-table-column
            v-for="(item, index) in voteResult.ShortlistHeader.slice(
              1,
              voteResult.ShortlistHeader.length
            )"
            :key="index"
            :label="item"
            width="90"
            align="center"
          >
            <template slot-scope="scope">
              <div
                v-for="(itme2, index2) in scope.row.ProjectStateList.slice(
                  1,
                  scope.row.ProjectStateList.length
                )"
                :key="itme2.Key"
              >
                <span v-if="index2 === index">{{ itme2.VoteNumbers }}</span>
              </div>
            </template>
          </el-table-column>

          <el-table-column
            label="分数（权重前）"
            width="120"
            align="center"
            key="ScoreBeforeWeight"
            v-if="voteResult.VoteType === 2"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.ScoreBeforeWeight }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="分数（权重后）"
            width="120"
            align="center"
            key="AllScore"
            v-if="voteResult.VoteType === 2"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.AllScore }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="总排序"
            width="120"
            align="center"
            key="VoteNum"
            v-if="voteResult.VoteType === 1"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.VoteNum }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="名次"
            width="120"
            align="center"
            key="RankingText"
            v-if="voteResult.VoteType === 1"
          >
            <template slot-scope="scope">
              <span>第{{ scope.row.Ranking }}名</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="chart_list_box" v-show="viewType === 'chart'">
          <VoteResultCharts
            ref="voteResultCharts"
            v-for="(item, index) in chartList"
            :key="index"
            :projectItem="item"
          ></VoteResultCharts>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import voteManageApi from '../../../../../api/vote/voteManage'
import VoteResultCharts from '@/components/VoteResultCharts.vue'
export default {
  components: {
    VoteResultCharts
  },
  data () {
    return {
      voteResult: {
        BaseNumberType: '1',
        ShortlistHeader: [],
        VoteProjectList: []
      },
      loading: true,
      isEditBaseNumber: false,
      viewType: 'table',
      chartList: []
    }
  },
  methods: {
    goBack: function () {
      this.$router.push({ name: 'meetingVote', params: { mid: this.$route.params.mid } })
    },
    getVoteResult: function () {
      const _this = this
      _this.loading = true
      voteManageApi.getVoteResult({
        voteId: _this.$route.params.vid
      }).then(data => {
        _this.voteResult = data
        if (!_this.voteResult.ShortlistHeader) {
          _this.voteResult.ShortlistHeader = []
        }
        if (_this.viewType === 'chart') {
          _this.chartList = _this.voteResult.VoteProjectList
        }
        _this.loading = false
      }).catch(err => {
        _this.loading = false
        return err
      })
    },
    refresh: function () {
      this.getVoteResult()
    },
    editBaseNumber: function () {
      this.isEditBaseNumber = true
    },
    cancelEditBaseNumber: function () {
      this.isEditBaseNumber = false
    },
    recreateResult: function () {
      const _this = this
      _this.loading = true
      voteManageApi.editVoteResultBaseNumber({
        VoteId: _this.$route.params.vid,
        BaseNumberType: _this.voteResult.BaseNumberType,
        CustomBaseNumber: _this.voteResult.CustomBaseNumber
      }).then(data => {
        this.isEditBaseNumber = false
        _this.getVoteResult()
      }).catch(err => {
        _this.loading = false
        return err
      })
    },
    editVoteResultSort: function () {
      const _this = this
      _this.loading = true
      voteManageApi.editVoteResultSort({
        VoteId: _this.$route.params.vid,
        ResultSortType: _this.voteResult.SortType === '票数' ? 1 : 0
      }).then(data => {
        _this.getVoteResult()
      }).catch(err => {
        _this.loading = false
        return err
      })
    },
    exportData: function () {
      const _this = this
      _this.openLoading()
      voteManageApi.exportVoteResult({
        VoteId: _this.$route.params.vid
      }).then(data => {
        if (!data) {
          return
        }
        let fileName = '投票结果'
        fileName = _this.voteResult.VoteName + '-投票结果'
        const fileUrl = window.URL.createObjectURL(new Blob([data], { type: 'application/vnd.ms-excel;charset=utf-8' }))

        const elink = document.createElement('a')
        // 设置下载文件名
        elink.setAttribute('download', fileName + '.xlsx')
        elink.style.display = 'none'
        elink.href = fileUrl
        document.body.appendChild(elink)
        elink.click()

        document.body.removeChild(elink) // 下载完成移除元素
        window.URL.revokeObjectURL(fileUrl) // 释放掉blob对象
        _this.openLoading().close()
      }).catch(err => {
        _this.openLoading().close()
        return err
      })
    },
    viewTypeChange: function () {
      const _this = this
      if (_this.viewType === 'chart') {
        _this.chartList = _this.voteResult.VoteProjectList
      }
    }
  },
  created () {
    this.getVoteResult()
  },
  mounted () {
  }
}
</script>
<style lang="less">
.form_bar_search .el-radio__label {
  padding-left: 5px;
}
.chart_list_box {
  width: 100%;
  display: -webkit-flex;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: flex-start;
}
</style>
